export default __webpack_public_path__ + "static/media/preloader.2425b429.png";